import { Box, Skeleton } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";


export function HeatmapSkeleton() {
  const rows = 10;
  const cols = 15;

  return (
    <Box className="w-full overflow-x-auto py-2 px-4 rounded-md bg-white">
      {Array.from(new Array(rows)).map((rowItem, rowIndex) => (
        <Box key={rowItem} className="flex justify-start">
          {rowIndex === 0 ? (
            <Box className="h-[28px] w-[250px] min-w-[250px] flex justify-center items-center mr-2">
              <Typography fontWeight="semibold" className="text-[#0D297D]">
                Detector List
              </Typography>
            </Box>
          ) : (
            <Skeleton
              variant="rounded"
              width={250}
              height={rowIndex === 0 ? 28 : 50}
              className="mr-2 mb-4 min-w-[250px]"
            />
          )}
          {Array.from(new Array(cols)).map((colItem) => (
            <Skeleton
              key={colItem}
              variant="rounded"
              height={rowIndex === 0 ? 28 : 50}
              className="mb-4 mr-2 w-[80px] min-w-[80px]"
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}
